export const examGeneral = (() => {
    const placeHolderText = 'Well-developed/nourished, NAD'

    return placeHolderText
})